import { useEffect, useState } from "react";
import { getCurrentYear } from "../api/requests";
import "./Copyrights.css";

export default function Copyrights() {
  const [currentYear, setCurrentYear] = useState(new Date().getFullYear());

  useEffect(() => {
    getCurrentYear().then((data) => {
      setCurrentYear(data);
    });
  }, []);

  return <div className="copy-rights">© {currentYear} Unilever</div>;
}
